import { createContext, useContext } from 'react'
import { useProfile } from '../hooks/useProfile'

const ProfileContext = createContext(null)

export function ProfileProvider({ children }) {
  return <ProfileContext.Provider value={useProfile()}>{children}</ProfileContext.Provider>
}

export function useProfileContext() {
  return useContext(ProfileContext)
}
